import React from 'react';
import { ArrowLeft, ArrowRight, Loader2 } from 'lucide-react';
import { CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import NotificationPreferencesSection from '@/components/signup/NotificationPreferencesSection';

export default function NotificationsStep({ value, onChange, loading, onBack, onSubmit }) {
  return (
    <>
      <CardHeader>
        <Button variant="ghost" size="sm" onClick={onBack} className="w-fit -ml-2 mb-2" data-testid="notifications-back-btn">
          <ArrowLeft className="w-4 h-4 mr-1" /> Back
        </Button>
        <CardTitle className="text-xl">Notification Preferences</CardTitle>
        <CardDescription>Last step — the defaults work well, and you can change them anytime in Settings</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <NotificationPreferencesSection value={value} onChange={onChange} />
        <Button className="w-full" disabled={loading} data-testid="notifications-submit-btn" onClick={onSubmit}>
          {loading ? (
            <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Creating Account...</>
          ) : (
            <>Create Account <ArrowRight className="w-4 h-4 ml-2" /></>
          )}
        </Button>
      </CardContent>
    </>
  );
}
